//#region src/utils/currentColors.ts
var e = {
	primary: "--brand-primary",
	secondary: "--brand-secondary",
	info: "--brand-info",
	success: "--brand-success",
	warning: "--brand-warning",
	danger: "--brand-danger"
}, t = (t) => `var(${e[`${t}`]})`;
//#endregion
export { t as getCurrentBackgroundColor };

//# sourceMappingURL=currentColors.js.map